import React from 'react';
import { Mail, Lock, Shield, Folder, Users, ClipboardList, Heart, Leaf, AlertTriangle, MessageSquare, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ComingSoonMockupPage() {
  return <div className="min-h-screen bg-[#fdfbf7] text-[#1e3a3a] font-sans selection:bg-[#1e3a3a] selection:text-white" data-id="element-1212" data-mp="2r0v48dpqf95n">
      <style data-id="element-1213" data-mp="30wy57g8ul1r0">{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600&display=swap');
        .font-fraunces {
          font-family: 'Fraunces', serif;
        }
      `}</style>

      {/* Header */}
      <header className="max-w-7xl mx-auto px-6 py-6 flex items-center justify-between" data-id="element-1214" data-mp="39x31ovci6fqe">
        <Link to="/" className="text-3xl font-fraunces font-semibold tracking-tight text-[#1e3a3a]" data-id="element-1215" data-mp="35xce10i9wfq3">
          Caveo
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-[#1e3a3a]" data-id="element-1216" data-mp="1bi9udjfwnrv3">
          <a href="#" className="hover:opacity-70 transition-opacity" data-id="element-1217" data-mp="3ggapcivi0754">
            How it Works
          </a>
          <a href="#" className="hover:opacity-70 transition-opacity" data-id="element-1218" data-mp="3leko13gflpvh">
            Our Pledges
          </a>
          <a href="#" className="hover:opacity-70 transition-opacity" data-id="element-1219" data-mp="3qdx6lc09sas9">
            Crisis Help
          </a>
          <a href="#" className="hover:opacity-70 transition-opacity" data-id="element-1220" data-mp="3v5yr1l7ld7td">
            About Us
          </a>
        </nav>
        <button className="hidden md:flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#1e3a3a] text-sm font-medium hover:bg-[#1e3a3a] hover:text-white transition-colors" data-id="element-1221" data-mp="3y2p7hpobrvq">
          <Mail size={16} data-id="element-1222" data-mp="d0lsu41aa8j1" />
          Join Waitlist
        </button>
      </header>

      <main className="max-w-7xl mx-auto px-6 pb-24 space-y-8" data-id="element-1223" data-mp="hynb4mqvy3tg">
        {/* Hero Section */}
        <section className="py-12 md:py-20 flex flex-col lg:flex-row items-center gap-12 lg:gap-8" data-id="element-1224" data-mp="2ergpsz788drc">
          <div className="flex-1 max-w-2xl" data-id="element-1225" data-mp="2joyqk2b3bmo9">
            <h1 className="text-5xl md:text-6xl font-fraunces font-medium leading-[1.1] tracking-tight mb-8 text-[#1e3a3a]" data-id="element-1226" data-mp="2jrunpof467bn">
              Guided digital protection for the people you love.
            </h1>
            <div className="w-16 h-[1px] bg-[#d2c5b8] mb-8" data-id="element-1227" data-mp="27pjts2dk5h9s"></div>
            <p className="text-lg text-[#3a4f4f] mb-10 leading-relaxed max-w-xl" data-id="element-1228" data-mp="2lo1f5tfzqhoj">
              Caveo helps families and adult children secure what matters
              most—accounts, devices, and important information.
            </p>
            <button className="flex items-center gap-2 bg-[#1e3a3a] text-white px-8 py-4 rounded-full font-medium hover:bg-[#152a2a] transition-colors shadow-sm mb-6" data-id="element-1229" data-mp="2ulk4vb4kxk6r">
              <Lock size={18} data-id="element-1230" data-mp="34d83bvzk01hq" />
              Join the Early Access List
              <ChevronRight size={18} className="ml-1" data-id="element-1231" data-mp="2zedae17vgwjw" />
            </button>
            <div className="flex items-center gap-2 text-sm text-[#5a6f6f]" data-id="element-1232" data-mp="3ebnu1xuo58qp">
              <Shield size={16} className="text-[#1e3a3a]" data-id="element-1233" data-mp="3e9jfmlz58rc6" />
              Private by design. Built for real life. Here when you need us.
            </div>
          </div>

          <div className="flex-1 relative w-full max-w-xl lg:max-w-none" data-id="element-1234" data-mp="3sz4ca9xf5p5y">
            {/* Placeholder for the illustration */}
            <div className="aspect-[4/3] rounded-2xl bg-[#e6ebe6] overflow-hidden relative shadow-inner border border-[#dce3de]" data-id="element-1235" data-mp="shb3mn4z44b">
              <img src="https://images.unsplash.com/photo-1511895426328-dc8714191300?q=80&w=2070&auto=format&fit=crop" alt="Family looking at view" className="w-full h-full object-cover opacity-60 mix-blend-multiply" data-id="element-1236" data-mp="3nz04d8aku2rc" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#e6ebe6] to-transparent opacity-50" data-id="element-1237" data-mp="309xcz8q54vjn"></div>
            </div>

            {/* Floating Cards */}
            <div className="absolute -right-4 top-12 space-y-4 hidden md:block" data-id="element-1238" data-mp="359a07ukxc4mr">
              <div className="bg-white p-4 rounded-xl shadow-lg border border-[#f0f0f0] flex items-start gap-4 w-64 transform transition-transform hover:-translate-y-1" data-id="element-1239" data-mp="2qd2lh9sabvev">
                <div className="w-10 h-10 rounded-full border border-[#1e3a3a] flex items-center justify-center shrink-0" data-id="element-1240" data-mp="2gnc2jy0b1py">
                  <Shield size={20} className="text-[#1e3a3a]" data-id="element-1241" data-mp="3tnzsuxuz9d5c" />
                </div>
                <div data-id="element-1242" data-mp="3ouwzapq7a3p5">
                  <h4 className="font-medium text-[#1e3a3a] text-sm mb-0.5" data-id="element-1243" data-mp="3oudso56031qf">
                    Secure
                  </h4>
                  <p className="text-xs text-[#5a6f6f] leading-tight" data-id="element-1244" data-mp="3jv14nh3e7om9">
                    Strong protection for everyday life.
                  </p>
                </div>
              </div>
              <div className="bg-white p-4 rounded-xl shadow-lg border border-[#f0f0f0] flex items-start gap-4 w-64 transform transition-transform hover:-translate-y-1 ml-4" data-id="element-1245" data-mp="3aya3iq9zhjkt">
                <div className="w-10 h-10 rounded-full border border-[#1e3a3a] flex items-center justify-center shrink-0" data-id="element-1246" data-mp="30zkgyk757ay8">
                  <Folder size={20} className="text-[#1e3a3a]" data-id="element-1247" data-mp="143mzneszidbs" />
                </div>
                <div data-id="element-1248" data-mp="z7fsjiouqvs9">
                  <h4 className="font-medium text-[#1e3a3a] text-sm mb-0.5" data-id="element-1249" data-mp="z4tk7gu50c8z">
                    Organized
                  </h4>
                  <p className="text-xs text-[#5a6f6f] leading-tight" data-id="element-1250" data-mp="1boqow7xwndy2">
                    All your important info in one place.
                  </p>
                </div>
              </div>
              <div className="bg-white p-4 rounded-xl shadow-lg border border-[#f0f0f0] flex items-start gap-4 w-64 transform transition-transform hover:-translate-y-1 ml-8" data-id="element-1251" data-mp="1lfl8t5noi1gc">
                <div className="w-10 h-10 rounded-full border border-[#1e3a3a] flex items-center justify-center shrink-0" data-id="element-1252" data-mp="ntntti8ice95">
                  <Users size={20} className="text-[#1e3a3a]" data-id="element-1253" data-mp="xoy0ij9up9t9" />
                </div>
                <div data-id="element-1254" data-mp="12ok92feqi1vq">
                  <h4 className="font-medium text-[#1e3a3a] text-sm mb-0.5" data-id="element-1255" data-mp="12ou3qgaq4x7r">
                    Shared
                  </h4>
                  <p className="text-xs text-[#5a6f6f] leading-tight" data-id="element-1256" data-mp="2944hvnejyi9h">
                    So the right people can help—when needed.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* How it works */}
        <section className="bg-[#fcfaf8] rounded-3xl p-10 md:p-12 border border-[#f0eae1] shadow-sm" data-id="element-1257" data-mp="9369bsxlbbeh">
          <h2 className="text-3xl font-fraunces font-medium text-center mb-12 text-[#1e3a3a]" data-id="element-1258" data-mp="n14mww4373sx">
            How it works in 3 steps
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-1259" data-mp="iygakeg5zer7">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-[1px] bg-[#e0d8ce] -z-10" data-id="element-1260" data-mp="3mhjdqdq2s8qj"></div>

            <div className="flex flex-col items-center text-center" data-id="element-1261" data-mp="43jx9mti0179">
              <div className="relative mb-6" data-id="element-1262" data-mp="3vhzevgjcj3s8">
                <div className="w-24 h-24 rounded-full bg-[#e6ebe6] flex items-center justify-center" data-id="element-1263" data-mp="3vh6506p3by5v">
                  <ClipboardList size={32} className="text-[#1e3a3a]" data-id="element-1264" data-mp="37r2d2wl9lmup" />
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-[#1e3a3a] text-white flex items-center justify-center text-sm font-medium border-4 border-[#fcfaf8]" data-id="element-1265" data-mp="33pqiecnjabfn">
                  1
                </div>
              </div>
              <h3 className="text-lg font-medium text-[#1e3a3a] mb-3" data-id="element-1266" data-mp="2yfeg4ldts0lw">
                We guide you
              </h3>
              <p className="text-sm text-[#5a6f6f] leading-relaxed max-w-xs" data-id="element-1267" data-mp="2onie4z8mbqce">
                Answer simple questions. We'll help you get organized without
                the overwhelm.
              </p>
            </div>

            <div className="flex flex-col items-center text-center" data-id="element-1268" data-mp="3hcp9xqgou1ty">
              <div className="relative mb-6" data-id="element-1269" data-mp="32f6nwvvea2q7">
                <div className="w-24 h-24 rounded-full bg-[#e6ebe6] flex items-center justify-center" data-id="element-1270" data-mp="32edgdsom3970">
                  <Lock size={32} className="text-[#1e3a3a]" data-id="element-1271" data-mp="37cop20367dnn" />
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-[#1e3a3a] text-white flex items-center justify-center text-sm font-medium border-4 border-[#fcfaf8]" data-id="element-1272" data-mp="1qyyi8lko2bab">
                  2
                </div>
              </div>
              <h3 className="text-lg font-medium text-[#1e3a3a] mb-3" data-id="element-1273" data-mp="1d67cq2nqka1i">
                We help you protect
              </h3>
              <p className="text-sm text-[#5a6f6f] leading-relaxed max-w-xs" data-id="element-1274" data-mp="13a4ev8zx2xkd">
                We secure your accounts, devices, and documents with clear,
                expert guidance.
              </p>
            </div>

            <div className="flex flex-col items-center text-center" data-id="element-1275" data-mp="1vy045sn5pn74">
              <div className="relative mb-6" data-id="element-1276" data-mp="1r08g59pmul87">
                <div className="w-24 h-24 rounded-full bg-[#e6ebe6] flex items-center justify-center" data-id="element-1277" data-mp="1r0i6wzii4wey">
                  <Users size={32} className="text-[#1e3a3a]" data-id="element-1278" data-mp="1m7p1saj4fm2c" />
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-[#1e3a3a] text-white flex items-center justify-center text-sm font-medium border-4 border-[#fcfaf8]" data-id="element-1279" data-mp="1i6vcbcq15z7c">
                  3
                </div>
              </div>
              <h3 className="text-lg font-medium text-[#1e3a3a] mb-3" data-id="element-1280" data-mp="29wzx3chpco93">
                You're never alone
              </h3>
              <p className="text-sm text-[#5a6f6f] leading-relaxed max-w-xs" data-id="element-1281" data-mp="1erkzbon55rp">
                Share access with trusted people and know help is here if
                something happens.
              </p>
            </div>
          </div>
        </section>

        {/* Two Column Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1282" data-mp="ffaoc5i5vnnj">
          {/* Pledges */}
          <section className="bg-[#f2f4f2] rounded-3xl p-10 border border-[#e6ebe6] flex flex-col" data-id="element-1283" data-mp="ke5ghy20qokb">
            <h2 className="text-2xl font-fraunces font-medium text-center mb-10 text-[#1e3a3a]" data-id="element-1284" data-mp="p4u6f8y1vdhc">
              Our pledges to you
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-10 flex-1" data-id="element-1285" data-mp="t55t0r9z3nvg">
              <div className="flex flex-col items-center text-center" data-id="element-1286" data-mp="y6bnoun71l7m">
                <div className="w-14 h-14 rounded-full bg-white border border-[#dce3de] flex items-center justify-center mb-4 shadow-sm" data-id="element-1287" data-mp="134dgi7af8ywa">
                  <Shield size={24} className="text-[#1e3a3a]" data-id="element-1288" data-mp="1h2sjv519nvtx" />
                </div>
                <h4 className="text-sm font-medium text-[#1e3a3a] mb-2" data-id="element-1289" data-mp="1lzst1otexep9">
                  Privacy first
                </h4>
                <p className="text-xs text-[#5a6f6f] leading-relaxed" data-id="element-1290" data-mp="1q0mfsev4cngk">
                  Your data stays private and under your control.
                </p>
              </div>
              <div className="flex flex-col items-center text-center" data-id="element-1291" data-mp="1zqxijy32gqlv">
                <div className="w-14 h-14 rounded-full bg-white border border-[#dce3de] flex items-center justify-center mb-4 shadow-sm" data-id="element-1292" data-mp="24qtoi2vbqs42">
                  <Heart size={24} className="text-[#1e3a3a]" data-id="element-1293" data-mp="29rhmx9lvub8b" />
                </div>
                <h4 className="text-sm font-medium text-[#1e3a3a] mb-2" data-id="element-1294" data-mp="2dqqhggoqyd4x">
                  Human-first support
                </h4>
                <p className="text-xs text-[#5a6f6f] leading-relaxed" data-id="element-1295" data-mp="fdyjxk9320fm">
                  Real people, real guidance, when you need it.
                </p>
              </div>
              <div className="flex flex-col items-center text-center" data-id="element-1296" data-mp="bv9fhgre69n9">
                <div className="w-14 h-14 rounded-full bg-white border border-[#dce3de] flex items-center justify-center mb-4 shadow-sm" data-id="element-1297" data-mp="72zkvnfc0len">
                  <Lock size={24} className="text-[#1e3a3a]" data-id="element-1298" data-mp="24y1t2hwom36" />
                </div>
                <h4 className="text-sm font-medium text-[#1e3a3a] mb-2" data-id="element-1299" data-mp="3u98mzi5zr6ue">
                  Bank-grade security
                </h4>
                <p className="text-xs text-[#5a6f6f] leading-relaxed" data-id="element-1300" data-mp="usamt88f4lud">
                  We use industry-leading security practices.
                </p>
              </div>
              <div className="flex flex-col items-center text-center" data-id="element-1301" data-mp="lr2quwtdjx3g">
                <div className="w-14 h-14 rounded-full bg-white border border-[#dce3de] flex items-center justify-center mb-4 shadow-sm" data-id="element-1302" data-mp="gtu9gyg1vx39">
                  <Leaf size={24} className="text-[#1e3a3a]" data-id="element-1303" data-mp="36k7kscnr4rxk" />
                </div>
                <h4 className="text-sm font-medium text-[#1e3a3a] mb-2" data-id="element-1304" data-mp="31iqn0q0kdll7">
                  Built for families
                </h4>
                <p className="text-xs text-[#5a6f6f] leading-relaxed" data-id="element-1305" data-mp="32yma7xk2765o">
                  Thoughtful by design. Peace of mind by default.
                </p>
              </div>
            </div>
            <div className="flex items-center justify-center gap-2 text-sm text-[#3a4f4f] pt-6 border-t border-[#dce3de]" data-id="element-1306" data-mp="2tzr74ucbac6l">
              <Lock size={16} data-id="element-1307" data-mp="2ka7ljgx7s481" />
              We will never sell your data. Ever.
            </div>
          </section>

          {/* Crisis */}
          <section className="bg-[#f7efe8] rounded-3xl p-10 border border-[#f0e2d5] flex flex-col items-center text-center" data-id="element-1308" data-mp="2p1zbpqcgk7xn">
            <h2 className="text-2xl font-fraunces font-medium mb-2 text-[#1e3a3a]" data-id="element-1309" data-mp="2adutenhbhyfe">
              Something just happened?
            </h2>
            <p className="text-[#5a6f6f] mb-10" data-id="element-1310" data-mp="21blku35m0f4n">
              If you've been hacked, scammed, or locked out—start here.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-10 w-full" data-id="element-1311" data-mp="2694x4xiqyhty">
              <div className="flex flex-col items-center" data-id="element-1312" data-mp="1mnuzd1sszv1r">
                <AlertTriangle size={28} className="text-[#1e3a3a] mb-4" strokeWidth={1.5} data-id="element-1313" data-mp="1mqhebmi0xcu0" />
                <h4 className="text-sm font-medium text-[#1e3a3a] mb-1" data-id="element-1314" data-mp="1vqw3wy20te3b">
                  Get calm
                </h4>
                <p className="text-xs text-[#5a6f6f]" data-id="element-1315" data-mp="1rpu1k8ct4lx4">
                  Take a breath.
                  <br data-id="element-1316" data-mp="25lo1w2zim2ym" />
                  We'll help.
                </p>
              </div>
              <div className="flex flex-col items-center" data-id="element-1317" data-mp="20nw976r1qctd">
                <Lock size={28} className="text-[#1e3a3a] mb-4" strokeWidth={1.5} data-id="element-1318" data-mp="2fdtqr3uh049l" />
                <h4 className="text-sm font-medium text-[#1e3a3a] mb-1" data-id="element-1319" data-mp="2agbsq8hzr9gd">
                  Secure first
                </h4>
                <p className="text-xs text-[#5a6f6f]" data-id="element-1320" data-mp="2jex9pz7tegf1">
                  Quick steps to lock
                  <br data-id="element-1321" data-mp="hprc721x12bm" />
                  things down.
                </p>
              </div>
              <div className="flex flex-col items-center" data-id="element-1322" data-mp="hnwz29wvyei3">
                <MessageSquare size={28} className="text-[#1e3a3a] mb-4" strokeWidth={1.5} data-id="element-1323" data-mp="mnjcokgmlwrf" />
                <h4 className="text-sm font-medium text-[#1e3a3a] mb-1" data-id="element-1324" data-mp="vhnzmssn2o1o">
                  Get guidance
                </h4>
                <p className="text-xs text-[#5a6f6f]" data-id="element-1325" data-mp="3uxb6xxyb1lpd">
                  Clear next steps
                  <br data-id="element-1326" data-mp="3p6vcbfk9gkr" />
                  from our team.
                </p>
              </div>
              <div className="flex flex-col items-center" data-id="element-1327" data-mp="7rafrpk7jvi6">
                <Users size={28} className="text-[#1e3a3a] mb-4" strokeWidth={1.5} data-id="element-1328" data-mp="7twnpqb0gd0x" />
                <h4 className="text-sm font-medium text-[#1e3a3a] mb-1" data-id="element-1329" data-mp="1j5xfzf732jlf">
                  You're not alone
                </h4>
                <p className="text-xs text-[#5a6f6f]" data-id="element-1330" data-mp="1o7wmgxy4dwml">
                  We're here with you
                  <br data-id="element-1331" data-mp="1y8yuw4o2wec3" />
                  the whole way.
                </p>
              </div>
            </div>
            <button className="flex items-center gap-2 px-6 py-3 rounded-full border border-[#1e3a3a] text-[#1e3a3a] font-medium hover:bg-[#1e3a3a] hover:text-white transition-colors mt-auto" data-id="element-1332" data-mp="1td0284vpwa5v">
              Go to Crisis Help
              <ChevronRight size={18} data-id="element-1333" data-mp="1fizes7a7u9kt" />
            </button>
          </section>
        </div>

        {/* Bottom CTA */}
        <section className="bg-[#e6ebe6] rounded-3xl p-8 md:p-12 border border-[#dce3de] flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-1334" data-mp="1ajwet193etjp">
          <div className="flex items-center gap-6" data-id="element-1335" data-mp="15mwaovvt00v8">
            <div className="w-16 h-16 rounded-full bg-[#1e3a3a] flex items-center justify-center shrink-0" data-id="element-1336" data-mp="11kj5q9ovs6zi">
              <Mail size={28} className="text-white" data-id="element-1337" data-mp="2zxszi2r7ixwq" />
            </div>
            <div data-id="element-1338" data-mp="2vwz6iuywqswz">
              <h2 className="text-2xl font-fraunces font-medium text-[#1e3a3a] mb-1" data-id="element-1339" data-mp="2vyk1glp4wdvd">
                Be the first to know.
              </h2>
              <p className="text-[#5a6f6f]" data-id="element-1340" data-mp="t90oqw5hc3ki">
                Join the waitlist for early access.
              </p>
            </div>
          </div>
          <div className="w-full md:w-auto flex-1 max-w-md" data-id="element-1341" data-mp="kb6udqr9zjzz">
            <div className="flex flex-col sm:flex-row gap-3" data-id="element-1342" data-mp="obqrwvfrgpmn">
              <input type="email" placeholder="Enter your email address" className="flex-1 px-5 py-4 rounded-full border border-[#dce3de] focus:outline-none focus:border-[#1e3a3a] focus:ring-1 focus:ring-[#1e3a3a]" data-id="element-1343" data-mp="ocackjwsps4d" />
              <button className="bg-[#1e3a3a] text-white px-8 py-4 rounded-full font-medium hover:bg-[#152a2a] transition-colors flex items-center justify-center gap-2 whitespace-nowrap" data-id="element-1344" data-mp="12zlmyih8r62w">
                Join Waitlist
                <ChevronRight size={18} data-id="element-1345" data-mp="3npb0ms67klu0" />
              </button>
            </div>
            <div className="flex items-center gap-2 text-xs text-[#5a6f6f] mt-4 ml-2" data-id="element-1346" data-mp="3sqqjcdkwyg98">
              <Lock size={14} data-id="element-1347" data-mp="3k86os8r9u3wv" />
              No spam. Just helpful updates and a heads-up when we launch.
            </div>
          </div>
        </section>
      </main>
    </div>;
}